<template>
  <sui-modal class="wrapper" v-model="visible" size="small" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Create project
    </sui-modal-header>
    <sui-modal-content>
      <sui-form :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <sui-form-field>
          <FormProject v-model="entity" mode="creating" />
        </sui-form-field>
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <div class="ui buttons">
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors" @click="submit()" data-goal="CREATE_PROJECT_TRY">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Success
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import ModalForm from '@/mixins/ModalForm'
  import FormProject from '@/components/forms/Project'
  import utils from '@/utils'

  export default {
    name: 'ModalCreateProject',
    mixins: [
      ModalForm,
    ],
    components: {
      FormProject,
    },
    methods: {
      open(entity = {}, callback) {
        this.visible = true
        this.$options.callback = callback
        this.entity = {
          ...entity,
          name: entity.name || utils.generateName(),
        }
      },
      onSuccess(result) {
        this.close()
        utils.reachGoal('CREATE_PROJECT_SUCCESS')
        if (this.$options.callback) {
          this.$options.callback(result)
        }
      },
      onFail() {
        utils.reachGoal('CREATE_PROJECT_FAIL')
      },
    },
    created() {
      this.$modals.createProject = this
    },
  }
</script>
